// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2JxBn";
export var footerImg = "footer-module--footerImg--OYfaA";